import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../UI/Typography'
import Button from '../UI/Button'
import { device } from '../../utils/helpers'

// Features
const Wrapper = styled.div`
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 120px;
  }
`

const Section = styled.section`
  background: ${props => props.grey ? props.theme.color.bgLight : '#fff'};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

const InfoSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #f3f3f3;
  padding: 4rem 0;

  @media ${device.laptop} {
    padding: 7rem 0;
  }
`

const Title = styled.div`
  padding: 3.6rem 1.5rem;
  text-align: center;
`

const BigTitle = styled.div`
  padding: 4.5rem 4.5rem 0 4.5rem;
  text-align: center;

  @media ${device.laptop} {
    width: 500px;
  }

  @media ${device.laptopL} {
    width: 700px;
  }
`

const Info = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  @media ${device.laptop} {
    width: 40%;
  }
`

const VideoSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #999999;
  padding: 4rem 1.5rem;

  @media ${device.laptop} {
    padding: 7rem 4rem;
  }

  @media ${device.desktop} {
    padding: 7rem 0;
  }
`

const ButtonWrapper = styled.div`
  padding: 1rem 0;

  @media ${device.tablet} {
    padding: 2.5rem 1.5rem;
  }

  @media ${device.laptop} {
    padding-bottom: 4rem;
  }
`

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3rem 0;

  @media ${device.tablet} {
    flex-direction: row;
    padding: 1.5rem 1.5rem;
  }

  @media ${device.laptop} {
    padding-bottom: 2rem;
  }
`

class ComeFunziona extends Component {
  render () {
    return (
      <Wrapper>
        <Helmet>
          <title>Configuratore Noleggiocampi.it</title>
          <meta name='Description' content='Con il CONFIGURATORE puoi configurare il noleggio tra diverse tipologie: campo da calcio, basket e beach volley e vedere in diretta il dettaglio dei costi!' />
          <meta name='Keywords' content='campi smontabili,noleggio attrezzature sportive,noleggio impianti sportivi mobili' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>COME FUNZIONA</Typography>
        </Title>
        <InfoSection>
          <Typography variant='h2' type='title'>come utilizzare il configuratore</Typography>
          <Info>
            <Typography padding='1.2rem 0' minSize='16px' maxSize='20px'>
              Noleggiocampi.it mette a disposizione un configuratore per creare la soluzione di noleggio su misura per ogni esigenza.<br />
              La configurazione richiede meno di 5 minuti e fornisce un preventivo in tempo reale!
            </Typography>
            <Typography padding='1.2rem 0' minSize='16px' maxSize='20px'>
              Guarda la video guida, è semplicissimo!
            </Typography>
          </Info>
        </InfoSection>
        <VideoSection>
          <iframe width='560' height='315' src='https://www.youtube.com/embed/-St4y-SnUVA' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen />
        </VideoSection>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>HAI ANCORA DOMANDE?</Typography>
          </BigTitle>
          <Buttons>
            <ButtonWrapper>
              <Button secondary to='/faq'>VISITA LE FAQ</Button>
            </ButtonWrapper>
            <ButtonWrapper>
              <Button secondary to='/contattaci'>CONTATTACI</Button>
            </ButtonWrapper>
          </Buttons>
        </Section>
      </Wrapper>
    )
  }
}

export default ComeFunziona



// WEBPACK FOOTER //
// ./src/components/Pages/ComeFunziona.js